module.exports = __webpack_public_path__ + "static/portfolio-8-5d85fe2228d0702acbd32ba1cb4be9f1.jpg";